var _path, _path2, _path3, _path4, _circle, _circle2, _circle3, _path5, _path6, _path7, _circle4, _circle5, _circle6, _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSteps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 292,
    height: 151,
    viewBox: "0 0 292 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M115 118C143.719 118 167 94.7188 167 66C167 37.2812 143.719 14 115 14C86.2812 14 63 37.2812 63 66C63 94.7188 86.2812 118 115 118Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M153 107C181.719 107 205 83.7188 205 55C205 26.2812 181.719 3 153 3C124.281 3 101 26.2812 101 55C101 83.7188 124.281 107 153 107Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M132 151C160.719 151 184 127.719 184 99C184 70.2812 160.719 47 132 47C103.281 47 80 70.2812 80 99C80 127.719 103.281 151 132 151Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M170 138C198.719 138 222 114.719 222 86C222 57.2812 198.719 34 170 34C141.281 34 118 57.2812 118 86C118 114.719 141.281 138 170 138Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 222,
    cy: 3,
    r: 3,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 145,
    r: 3,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 8,
    r: 3,
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2 26.5L18 30.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 117.5L42.5 112",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M234 44.5L254.5 40",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 270,
    cy: 138,
    r: 2,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 290.5,
    cy: 73.5,
    r: 1.5,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 82.5,
    r: 1.5,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11304_9687)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.001 127C175.72 127 199.001 103.719 199.001 75C199.001 46.2812 175.72 23 147.001 23C118.282 23 95.001 46.2812 95.001 75C95.001 103.719 118.282 127 147.001 127Z",
    fill: "#006FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.702 83.7749L153.223 82.6583C151.309 79.6277 150.352 75.3209 150.033 70.8546C149.554 60.4865 153.223 52.3516 159.125 51.873H159.444C164.708 51.873 169.493 59.2105 170.291 69.2596C170.61 73.7258 169.972 77.873 168.696 81.2227L168.377 82.3393H167.26C165.346 82.0203 162.953 82.0203 161.199 82.3393C159.125 82.3393 156.892 82.9773 155.137 83.4559L153.702 83.7749Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.462 80.9038L140.94 79.7872C142.855 76.7566 143.812 72.4498 144.131 67.9836C144.609 57.6155 140.94 49.4805 135.039 49.002H134.879C129.615 49.002 124.83 56.3394 124.032 66.3885C123.713 70.8547 124.351 75.002 125.628 78.3517L125.947 79.4682H126.904C128.818 79.1492 131.21 79.1492 132.965 79.4682C135.039 79.4682 137.272 80.1062 139.026 80.5848L140.462 80.9038Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.082 101.161C155.616 101.161 152.585 95.8974 152.904 89.517C152.904 89.0385 152.904 88.2409 152.904 87.7624L153.223 86.4863L167.419 86.9649V88.4004C167.419 88.879 167.419 89.6765 167.419 90.155C167.579 96.3759 164.229 101.161 160.082 101.161Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.923 98.2901C138.389 98.2901 141.42 93.0263 141.101 86.6459C141.101 86.1674 141.101 85.3698 141.101 84.8913L140.782 83.6152L126.585 84.0938V85.3698C126.585 85.8484 126.585 86.6459 126.585 87.1244C126.426 93.3453 129.935 98.2901 133.923 98.2901Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_11304_9687)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.4802 83.1899C92.7169 82.4962 102.885 71.2034 102.191 57.9667C101.498 44.73 90.2048 34.562 76.9681 35.2557C63.7314 35.9494 53.5633 47.2422 54.257 60.4788C54.9507 73.7155 66.2435 83.8836 79.4802 83.1899Z",
    fill: "#006FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5237 63.1063L81.2762 62.6032C80.3208 61.2526 79.7756 59.2907 79.5207 57.2399C79.0497 52.4727 80.5442 48.6347 83.2528 48.2716L83.3998 48.2639C85.826 48.1367 88.2088 51.403 88.8191 56.0154C89.074 58.0662 88.8801 59.9931 88.3729 61.5678L88.2528 62.0902L87.7382 62.1171C86.8482 62.0163 85.7455 62.0741 84.9445 62.2636C83.9887 62.3136 82.9749 62.6617 82.1777 62.9246L81.5237 63.1063Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3522 62.1038L75.5458 61.5776C76.3548 60.1345 76.6919 58.1264 76.731 56.0601C76.7011 51.2698 74.8137 47.609 72.0819 47.531L72.0084 47.5349C69.5823 47.662 67.554 51.1595 67.4291 55.8104C67.39 57.8766 67.7842 59.7727 68.4533 61.2858L68.6273 61.7927L69.0684 61.7696C69.9429 61.5763 71.0457 61.5185 71.8621 61.6232C72.8179 61.5731 73.8625 61.8132 74.6828 61.9914L75.3522 62.1038Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8853 70.9667C82.8268 71.0746 81.3028 68.7217 81.2957 65.7733C81.2842 65.5527 81.2649 65.1851 81.2533 64.9645L81.3696 64.3687L87.9243 64.2463L87.959 64.908C87.9705 65.1286 87.9898 65.4962 88.0013 65.7167C88.2251 68.5801 86.7968 70.8666 84.8853 70.9667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7583 70.2739C74.8168 70.166 76.0865 67.6667 75.7854 64.7336C75.7738 64.5131 75.7545 64.1455 75.743 63.9249L75.5651 63.3445L69.0335 63.9079L69.0643 64.4961C69.0759 64.7166 69.0952 65.0842 69.1067 65.3048C69.1835 68.1759 70.9203 70.3702 72.7583 70.2739Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_11304_9687)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.966 119.289C247.305 120.041 259.539 109.026 260.291 94.6858C261.042 80.3461 250.027 68.1122 235.687 67.3607C221.347 66.6092 209.113 77.6246 208.362 91.9644C207.61 106.304 218.626 118.538 232.966 119.289Z",
    fill: "#006FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.444 97.8816L237.234 97.3116C236.358 95.7482 235.992 93.5728 235.95 91.3344C235.982 86.1449 238.027 82.179 240.986 82.0945L241.146 82.1028C243.774 82.2406 245.971 86.0295 246.107 91.068C246.149 93.3064 245.722 95.3605 244.997 96.9997L244.809 97.5488L244.251 97.5196C243.304 97.3102 242.109 97.2476 241.225 97.361C240.189 97.3067 239.057 97.5669 238.169 97.7599L237.444 97.8816Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.905 96.1033L231.173 95.5583C232.209 94.0951 232.799 91.9698 233.075 89.748C233.586 84.5836 231.967 80.4257 229.032 80.0323L228.953 80.0281C226.324 79.8904 223.743 83.4289 223.082 88.4257C222.806 90.6474 223.016 92.7348 223.565 94.4408L223.695 95.0067L224.173 95.0317C225.137 94.9225 226.332 94.9851 227.2 95.1903C228.235 95.2446 229.333 95.6216 230.197 95.9064L230.905 96.1033Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.171 106.729C237.941 106.612 236.566 103.904 236.892 100.727C236.905 100.488 236.926 100.09 236.938 99.8507L237.131 99.2218L244.207 99.8323L244.169 100.549C244.157 100.788 244.136 101.186 244.123 101.425C244.04 104.536 242.242 106.837 240.171 106.729Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.186 104.617C229.416 104.734 231.067 102.185 231.074 98.9909C231.087 98.752 231.108 98.3537 231.12 98.1148L230.994 97.4693L223.893 97.3367L223.86 97.9739C223.847 98.2128 223.827 98.6111 223.814 98.85C223.572 101.952 225.194 104.513 227.186 104.617Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11304_9687"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 104,
    fill: "white",
    transform: "translate(95 23)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_11304_9687"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(53 36.5117) rotate(-3)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_11304_9687"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "white",
    transform: "translate(209.722 66) rotate(3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSteps);
export default __webpack_public_path__ + "static/media/steps.9b20218bad300fa8ae354774d2a85949.svg";
export { ForwardRef as ReactComponent };